var map = {
	"./acsi.json": 1502,
	"./de-de.json": 1503,
	"./en-us.json": 656,
	"./id.json": 1504,
	"./ja.json": 1505,
	"./ko.json": 1506,
	"./vi.json": 1507,
	"./whitelists/whitelist_acsi.json": 1508,
	"./whitelists/whitelist_de-de.json": 1509,
	"./whitelists/whitelist_en-us.json": 1510,
	"./whitelists/whitelist_en.json": 1511,
	"./whitelists/whitelist_id.json": 1512,
	"./whitelists/whitelist_ja.json": 1513,
	"./whitelists/whitelist_ko.json": 1514,
	"./whitelists/whitelist_vi.json": 1515,
	"./whitelists/whitelist_zh-cn.json": 1516,
	"./whitelists/whitelist_zh-tw.json": 1517,
	"./zh-cn.json": 1518,
	"./zh-tw.json": 1519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1501;